"use strict";

exports.__esModule = true;
exports.default = void 0;
var _index = require("./index");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const arrayMerge = (destinationArray, sourceArray, options) => sourceArray; // tells deepmerge not to merge arrays

class ReducerHelper {
  constructor(options, cases = {}, initial = {}) {
    _defineProperty(this, "reduce", (state = this._initial, action) => {
      if (this.cases[action.type]) {
        return this.cases[action.type](state, action);
      }
      return state;
    });
    this._initial = {
      schema: initial.schema,
      // should be set otherwise the deepmerge will throw errors
      list: {
        schema: initial.schema,
        fetching: false,
        fetched: false,
        page: 0,
        limit: 25,
        limits: [5, 10, 25, 50, 100, 200],
        selection: [],
        error: null,
        errors: [],
        filters: [],
        order: []
      },
      single: {
        schema: initial.schema
      },
      create: {
        schema: initial.schema
      },
      edit: {
        schema: initial.schema
      },
      import: {
        schema: initial.schema
      }
    };
    this._singular = options.singular || (options.plural ? options.plural.slice(0, -1) : null);
    this._plural = options.plural || (options.singular ? options.singular + 's' : null);
    this._singular = this._singular.toUpperCase();
    this._plural = this._plural.toUpperCase();
    this._data = null;
    this._selection = [];
    this._current = null;
    let list;
    let single;
    this.cases = {
      ['INIT_' + this._plural]: (state, action) => {
        const mergedSchema = action.data.schema ? (0, _index.deepmerge)(state.schema, action.data.schema, {
          arrayMerge
        }) : state.schema;
        const mergedImport = _index.deepmerge.all([state.import, action.data.import || {}, {
          schema: mergedSchema
        }], {
          arrayMerge
        });
        const mergedList = _index.deepmerge.all([state.list, action.data.list || {}, {
          schema: mergedSchema
        }], {
          arrayMerge
        });
        const mergedCreate = _index.deepmerge.all([state.create, action.data.create || {}, {
          schema: mergedSchema
        }], {
          arrayMerge
        });
        const mergedSingle = _index.deepmerge.all([state.single, action.data.single || {}, {
          schema: mergedSchema
        }], {
          arrayMerge
        });
        const mergedEdit = _index.deepmerge.all([state.edit, action.data.edit || {}, {
          schema: mergedSchema
        }], {
          arrayMerge
        });
        return {
          ...state,
          expand: action.data.expand,
          schema: mergedSchema,
          editable: (0, _index.filterEditable)(action.data),
          list: {
            ...mergedList,
            schema: (0, _index.filterSchema)(mergedList.schema, [{
              key: 'visible',
              value: false
            }])
          },
          create: {
            ...mergedCreate,
            schema: (0, _index.filterSchema)(mergedCreate.schema, [{
              key: 'visible',
              value: false
            }, {
              key: 'guarded',
              value: true
            }])
          },
          single: {
            ...mergedSingle,
            schema: (0, _index.filterSchema)(mergedSingle.schema, [{
              key: 'visible',
              value: false
            }])
          },
          edit: {
            ...mergedEdit,
            schema: (0, _index.filterSchema)(mergedEdit.schema, [{
              key: 'visible',
              value: false
            }, {
              key: 'guarded',
              value: true
            }, {
              key: 'type',
              value: 'Join'
            }, {
              key: 'type',
              value: 'RelationPicture'
            }])
          },
          import: {
            ...mergedImport,
            schema: (0, _index.filterSchema)(mergedImport.schema, [{
              key: 'visible',
              value: false
            }, {
              key: 'guarded',
              value: true
            }])
          }
        };
      },
      ['SELECT_' + this._singular]: (state, action) => {
        this._selection = state.list.selection.filter(id => id !== action.id);
        return {
          ...state,
          list: {
            ...state.list,
            selection: [...this._selection, action.id]
          }
        };
      },
      ['DESELECT_' + this._singular]: (state, action) => {
        this._selection = state.list.selection.filter(id => id !== action.id);
        return {
          ...state,
          list: {
            ...state.list,
            selection: this._selection
          }
        };
      },
      ['SELECT_ALL_' + this._plural]: (state, action) => {
        this._selection = state.list.data.map(d => d.Id);
        return {
          ...state,
          list: {
            ...state.list,
            selection: this._selection
          }
        };
      },
      ['DESELECT_ALL_' + this._plural]: (state, action) => {
        return {
          ...state,
          list: {
            ...state.list,
            selection: []
          }
        };
      },
      ['FLIP_' + this._plural + '_FORWARD']: (state, action) => {
        if (state.list.page + 1 < Math.ceil(state.list.total / state.list.limit)) {
          return {
            ...state,
            list: {
              ...state.list,
              page: state.list.page + 1
            }
          };
        }
        return state;
      },
      ['FLIP_' + this._plural + '_BACKWARD']: (state, action) => {
        return {
          ...state,
          list: {
            ...state.list,
            page: state.list.page > 0 ? state.list.page - 1 : state.list.page
          }
        };
      },
      ['JUMP_' + this._plural]: (state, action) => {
        return {
          ...state,
          list: {
            ...state.list,
            page: action.data
          }
        };
      },
      ['ORDER_BY_' + this._plural]: (state, action) => {
        return {
          ...state,
          list: {
            ...state.list,
            order: action.data ? [...action.data] : []
          }
        };
      },
      ['SET_' + this._plural + '_LIMIT']: (state, action) => {
        return {
          ...state,
          list: {
            ...state.list,
            page: 0,
            limit: action.data
          }
        };
      },
      ['SET_' + this._plural + '_FILTER']: (state, action) => {
        return {
          ...state,
          list: {
            ...state.list,
            filters: [...state.list.filters, action.data]
          }
        };
      },
      ['DELETE_' + this._plural + '_FILTER']: (state, action) => {
        return {
          ...state,
          list: {
            ...state.list,
            filters: [...state.list.filters.filter(filter => filter.id !== action.data.id)]
          }
        };
      },
      ['DELETE_ALL_' + this._plural + '_FILTERS']: state => {
        return {
          ...state,
          list: {
            ...state.list,
            filters: []
          }
        };
      },
      ['GET_' + this._plural + '_REQUEST']: state => {
        return {
          ...state,
          list: {
            ...state.list,
            fetching: true,
            fetched: false
          }
        };
      },
      ['GET_' + this._plural + '_SUCCESS']: (state, action) => {
        return {
          ...state,
          list: {
            ...state.list,
            selection: [],
            data: action.data,
            total: action.total,
            fetching: false,
            fetched: true,
            error: null
          }
        };
      },
      /* Custom cases, just for updating the users list with their profile picture */

      ['GET_IMAGE_REQUEST']: (state, action) => {
        return {
          ...state,
          list: {
            ...state.list,
            fetching: true,
            fetched: false
          }
        };
      },
      ['GET_IMAGE_SUCCESS']: (state, action) => {
        let img = action.data;
        if (state.list.data) {
          list = {
            ...state.list,
            fetching: false,
            fetched: true,
            error: null,
            data: state.list.data.map(item => {
              if (item.Id === img.UserId) {
                return {
                  ...item,
                  UserImage: img
                };
              } else return item;
            })
          };
        } else list = {
          ...state.list
        };
        return {
          ...state,
          list
        };
      },
      ['GET_IMAGE_FAILURE']: (state, action) => {
        return {
          ...state,
          single: {
            ...state.single,
            fetching: false,
            fetched: true,
            error: action.data
          }
        };
      },
      /* End of custom cases */

      ['GET_' + this._plural + '_FAILURE']: (state, action) => {
        return {
          ...state,
          list: {
            ...state.list,
            fetching: false,
            fetched: false,
            error: action.data
          }
        };
      },
      ['GET_' + this._singular + '_REQUEST']: state => {
        return state;
        /* 
                        return {
                            ...state,
                            single: {
                                ...state.single,
                                fetching: true,
                                fetched: false,
                            },
        
                        }
        */
      },
      /* [`GET_${this._singular}_REQUEST`]: (state) => {
           return state
           return {
              ...state,
              single: {
                  ...state.single,
                  fetching: true,
                  fetched: false,
                  // error: null,
                  // message: null,
                  //data: null,
              },
           }
       }, */

      ['GET_' + this._singular + '_SUCCESS']: (state, action) => {
        return {
          ...state,
          single: {
            ...state.single,
            fetching: false,
            fetched: true,
            data: action.data
          }
        };
      },
      ['GET_' + this._singular + '_FAILURE']: (state, action) => {
        return {
          ...state,
          single: {
            ...state.single,
            fetching: false,
            fetched: true,
            error: action.data
          }
        };
      },
      ['UPDATE_' + this._singular + '_SUCCESS']: (state, action) => {
        list = {
          ...state.list,
          data: [...(state.list.data ? state.list.data.filter(d => d.Id !== action.data.Id) : []), action.data]
        };
        single = {
          ...state.single,
          data: action.data
        };
        return {
          ...state,
          list,
          single
        };
      },
      ['UPDATE_' + this._singular + '_FAILURE']: (state, action) => {
        return {
          ...state,
          single: {
            ...state.single,
            fetching: false,
            fetched: true,
            error: action.data
          }
        };
      },
      [`DELETE_${this._singular}_SUCCESS`]: (state, action) => {
        this._data = state.list.data ? state.list.data.filter(d => d.Id !== action.data.Id) : null;
        this._selection = state.list.selection.filter(s => s !== action.data.Id);
        return {
          ...state,
          list: {
            ...state.list,
            ...(this._data ? {
              data: this._data
            } : []),
            total: --state.list.total,
            selection: this._selection
          }
        };
      },
      [`DELETE_${this._singular}_FAILURE`]: (state, action) => {
        return {
          ...state,
          list: {
            ...state.list,
            errors: state.list.errors ? [...state.list.errors, action.data] : [action.data]
          }
        };
      },
      ['CREATE_' + this._singular + '_REQUEST']: (state, action) => {
        return {
          ...state,
          single: {
            ...state.single,
            fetching: true,
            fetched: false
          }
        };
      },
      ['CREATE_' + this._singular + '_SUCCESS']: (state, action) => {
        return {
          ...state,
          list: {
            ...state.list,
            total: state.total++,
            fetching: false,
            fetched: true,
            data: [...(state.list.data ? state.list.data : []), action.data]
          },
          single: {
            ...state.single,
            fetching: false,
            fetched: true,
            data: action.data
          }
        };
      },
      ['CREATE_' + this._singular + '_FAILURE']: (state, action) => {
        return {
          ...state,
          single: {
            ...state.single,
            fetching: false,
            fetched: true,
            error: action.data
          }
        };
      },
      [`${this._singular}_ERROR_CLOSED`]: (state, action) => {
        switch (action.data.where) {
          case 'list':
            return {
              ...state,
              list: {
                ...state.list,
                errors: state.list.errors.filter(error => error.id !== action.data.id)
              }
            };
        }
        return state;
      },
      ...cases
    };
  }
}
var _default = exports.default = ReducerHelper;
module.exports = exports.default;